$(function () {
    $(".widget-bar-chart").each(function (idx, element) {
        //var lineColor = $(element).data("line-color");
        //var lineWidth = $(element).data("line-width");
        //var beginsAtZero = $(element).data("begins-at-zero");
        var dataUrl = $(element).data("url");
        var $canvas = $(element).find("canvas");
        var $error = $(element).find(".chart-error");
        var $empty = $(element).find(".chart-empty");
        var canvas = $canvas.get(0);
        var $spinner = $(element).find(".bounce-spinner");
        var defaultBarColor = "#2196F3";//TODO: pass this in options?

        if (!canvas) return;

        

        /**
         * Processes the data retrieved from the server
         */
        var _processData = function (d) {
            //validate json schema
            if (!d && !d.Data && !(d instanceof Array) && !(d.Data instanceof Array)) {
                _showError("Invalid data received");
                return;
            }

            if (d.length == 0) {
                $error.hide();
                $spinner.hide();
                $canvas.hide();
                $empty.show();
                return;
            }

            var array = [];
            var chartLabels = [];
            var chartData = [];
            var chartColors = [];

            if (d instanceof Array) array = d;
            else if (d.Data instanceof Array) array = d.Data;

            //generate labels (X Axis)
            for (var i = 0; i < array.length; i++) {
                var ds = array[i];

                if (!chartLabels.contains(ds.Label))
                    chartLabels.push(ds.Label);
            }

            for (var i = 0; i < chartLabels.length; i++) {
                var items = array.filter(function (value, idx) {
                    return value.Label == chartLabels[i];
                });

                if (items.length > 0) {
                    chartData.push(items[0].Value);
                    chartColors.push(items[0].Color || defaultBarColor);
                }
                else {
                    chartData.push(0);
                    chartColors.push(defaultBarColor);
                }
            }

            $spinner.hide();
            $canvas.show();

            var context = canvas.getContext('2d');

            var chart = new Chart(context, {
                type: 'bar',
                data: {
                    labels: chartLabels,
                    datasets: [{
                        type: 'bar',
                        label: '',
                        data: chartData,
                        fill: false,
                        backgroundColor: chartColors,
                        borderWidth: 0
                    }]
                },
                options: {
                    legend: { display: false },
                    maintainAspectRatio: false,
                    tooltips: {
                        xPadding: 12,
                        yPadding: 12,
                        displayColors: false
                    },
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: { display: true, beginAtZero: true }
                        }],
                        xAxes: [{
                            display: true,
                            maxBarThickness: 30,
                            gridLines: { display: false }
                        }]
                    },
                    animation: {
                        animateScale: false
                    }
                }
            });
        }

        /**
         * Displays an error message
         */
        var _showError = function (err) {
            $canvas.hide();
            $spinner.hide();

            if (err) {
                $error.find("p").html(err);
            }

            $error.show();
        };

        /**
         * Fetches the chart data from the data url
         */
        var _fetchData = function () {
            $.ajax({
                url: dataUrl,
                method: 'GET',
                dataType: 'json',
                success: function (d) {
                    _processData(d);
                },
                error: function (x, s, e) {
                    _showError();
                }
            });
        }

        _fetchData();
    });
});